import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Textarea from "../../../components/ui/Textarea";
import { Checkbox } from "../../../components/ui/Checkbox";

const TagFormModal = ({
  isOpen,
  onClose,
  onSave,
  tag,
  mode,
  language = "ar",
  isLoadingAction = false,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    is_car: false,
    is_product: false,
    is_workshop: false,
    is_emergency: false,
    image: null,
  });

  const [errors, setErrors] = useState({});

  const labels = {
    addTitle: { ar: "إضافة تاغ", en: "Add Tag" },
    editTitle: { ar: "تعديل تاغ", en: "Edit Tag" },
    name: { ar: "اسم التاغ", en: "Tag Name" },
    description: { ar: "الوصف", en: "Description" },
    is_car: { ar: "خاص بسيارة", en: "Car Tag" },
    is_product: { ar: "خاص بمنتج", en: "Product Tag" },
    is_workshop: { ar: "خاص بورشة", en: "Workshop Tag" },
    is_emergency: { ar: "خاص بالطوارئ", en: "Emergency Tag" },
    image: { ar: "الصورة", en: "Image" },
    cancel: { ar: "إلغاء", en: "Cancel" },
    save: { ar: "حفظ", en: "Save" },
    required: { ar: "هذا الحقل مطلوب", en: "This field is required" },
  };

  // تحميل بيانات عند التعديل
  useEffect(() => {
    if (tag) {
      setFormData({
        name: tag.name || "",
        description: tag.description || "",
        is_car: tag.is_car || false,
        is_product: tag.is_product || false,
        is_workshop: tag.is_workshop || false,
        is_emergency: tag.is_emergency || false,
        image: null,
      });
    } else {
      setFormData({
        name: "",
        description: "",
        is_car: false,
        is_product: false,
        is_workshop: false,
        is_emergency: false,
        image: null,
      });
    }

    setErrors({});
  }, [tag, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = labels.required[language];

    if (!formData.description.trim())
      newErrors.description = labels.required[language];

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const submitData = new FormData();
    submitData.append("name", formData.name);
    submitData.append("description", formData.description);
    submitData.append("is_car", formData.is_car ? 1 : 0);
    submitData.append("is_product", formData.is_product ? 1 : 0);
    submitData.append("is_workshop", formData.is_workshop ? 1 : 0);
    submitData.append("is_emergency", formData.is_emergency ? 1 : 0);
    if (formData.image) {
      submitData.append("image", formData.image);
    }

    onSave(submitData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-card w-full max-w-xl rounded-xl border border-border">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-6 py-4">
          <h2 className="text-xl font-semibold">
            {mode === "add"
              ? labels.addTitle[language]
              : labels.editTitle[language]}
          </h2>
          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <Input
            label={labels.name[language]}
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            error={errors.name}
            required
          />

          <Textarea
            label={labels.description[language]}
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            error={errors.description}
          />

          <div>
            <label className="block mb-2 font-medium">
              {labels.image[language]}
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setFormData({ ...formData, image: e.target.files[0] })
              }
              className="border p-2 w-full rounded"
            />
          </div>

          <Checkbox
            label={labels.is_car[language]}
            checked={formData.is_car}
             onChange={(e) => {
              setFormData({ ...formData, is_car: e.target.checked });
            }}
          
          />

          <Checkbox
            label={labels.is_product[language]}
            checked={formData.is_product}
            onChange={(e) => {
              setFormData({ ...formData, is_product: e.target.checked });
            }}
          />

          <Checkbox
            label={labels.is_workshop[language]}
            checked={formData.is_workshop}
            onChange={(e) => {
              setFormData({ ...formData, is_workshop: e.target.checked });
            }}
          />

          <Checkbox
            label={labels.is_emergency[language]}
            checked={formData.is_emergency}
            onChange={(e) => {
              setFormData({ ...formData, is_emergency: e.target.checked });
            }}
          />

          {/* Actions */}
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" fullWidth onClick={onClose}>
              {labels.cancel[language]}
            </Button>

            <Button
              type="submit"
              variant="default"
              fullWidth
              loading={isLoadingAction}
            >
              {labels.save[language]}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TagFormModal;
